import { Button, IconButton, Stack, Tooltip } from "@mui/material";
import EditOutlinedIcon from "@mui/icons-material/Edit";
import DeleteOutlineIcon from "@mui/icons-material/Delete";
export default function RowActions({
  actions = [],
  label = "Record actions",
  variant = "icon",
}) {
  const visible = actions.filter((action) => action.visible !== false);
  if (!visible.length) return null;
  return (
    <Stack
      direction="row"
      spacing={1}
      alignItems="center"
      justifyContent="center"
      sx={{ width: "100%", height: "100%" }}
      aria-label={label}
    >
      {visible.map((action) => {
        const isDelete =
          action.danger || action.label.toLowerCase() === "delete";
        const Icon =
          action.icon ||
          (isDelete
            ? DeleteOutlineIcon
            : action.label.toLowerCase() === "edit"
            ? EditOutlinedIcon
            : null);
        if (variant === "button")
          return (
            <Button
              key={action.label}
              variant="outlined"
              size="small"
              startIcon={Icon ? <Icon fontSize="small" /> : undefined}
              endIcon={action.endIcon}
              disabled={action.disabled}
              color={isDelete ? "error" : "primary"}
              aria-label={`${action.label} ${label.replace(
                /^Actions for /,
                ""
              )}`}
              onClick={action.onClick}
              sx={{ whiteSpace: "nowrap" }}
            >
              {action.label}
            </Button>
          );
        return (
          <Tooltip title={action.label} key={action.label}>
            <IconButton
              aria-label={`${action.label} ${label.replace(
                /^Actions for /,
                ""
              )}`}
              disabled={action.disabled}
              color={isDelete ? "error" : "primary"}
              size="small"
              onClick={action.onClick}
            >
              {Icon ? <Icon fontSize="small" /> : action.label}
            </IconButton>
          </Tooltip>
        );
      })}
    </Stack>
  );
}
